import { __extends as r } from "./index11.js";
import { PersistedPriorityQueue as o } from "./index19.js";
import { CoreEventQueue as u } from "./index50.js";
var f = (
  /** @class */
  function(t) {
    r(n, t);
    function n(e) {
      return t.call(this, e ?? new o(4, "event-queue")) || this;
    }
    return n;
  }(u)
);
export {
  f as EventQueue
};
//# sourceMappingURL=index16.js.map
